import { EuiConfirmModal, EuiText, EuiCallOut } from "@inscopix/ideas-eui";
import { useProjectDataContext } from "pages/project/ProjectDataProvider";

interface ModalProjectSyncErrorProps {
  onClose: () => void;
}

/* Modal to display when there is an error syncing changes to the project.
 * Consumes {@link useProjectDataContext} to reset the data table provider key
 */
export const ModalProjectSyncError = ({
  onClose,
}: ModalProjectSyncErrorProps) => {
  const { resetDataTableProviderKey } = useProjectDataContext();
  return (
    <EuiConfirmModal
      title="Error syncing changes"
      onCancel={onClose}
      onConfirm={() => {
        resetDataTableProviderKey();
        onClose();
      }}
      cancelButtonText="Close"
      confirmButtonText="Revert to saved"
      buttonColor="warning"
      defaultFocusedButton="confirm"
    >
      <EuiText>
        <EuiCallOut color="warning">
          <p>
            IDEAS was not able to successfully sync the most recent changes. Use
            the revert button below to reset the project to the most recent
            saved stage so you can continue working.
          </p>
          <p>
            If you have unsaved work you wish to preserve, you can close this
            warning and copy it elsewhere. However, you will not be able to make
            any more changes to this project until you reload.
          </p>
        </EuiCallOut>
      </EuiText>
    </EuiConfirmModal>
  );
};
